import classNames from 'classnames'
import { push } from 'connected-react-router'
import { FirebaseDocRefType } from 'firebase/index'
import React, { FC, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getExpiration } from 'lib/pointCard'
import styles from 'styles/components/card.module.scss'
import { PointCardStatus, PointCardType } from 'types/pointCard'
import { PointCardOfferType as BasePointCardOfferType } from 'types/pointCard/pointCardOffer'
import { BlueButton } from 'components/Button'
import { PointCardOfferList } from 'components/List'
import { openCautionModal } from 'reducks/modal/operations'

type PointCardOfferType = BasePointCardOfferType & { ref: FirebaseDocRefType }

type Props = {
  onPublish: () => Promise<void>
  onSuspend: () => Promise<void>
  pointCard: PointCardType
  pointCardOffers: PointCardOfferType[]
  pointCardUsersAmount: number
}

const PointCardCard: FC<Props> = (props) => {
  const { onPublish: handlePublish, onSuspend: handleSuspend, pointCard, pointCardOffers, pointCardUsersAmount } = props

  const dispatch = useDispatch()

  const handleCreateOffer = () => {
    dispatch(push('/point_card/offer/create'))
  }

  const handleOpenConfirmModal = useCallback(() => {
    dispatch(
      openCautionModal(
        '停止する',
        'キャンセル',
        `お客さまが、ポイントカードを新しく取得できなくなります。\n<span style="color: red">※すでにお客さまが取得したポイントカードは削除されません。</span>`,
        handleSuspend,
        `<p style="text-align: left">新規受付を停止します</p>`
      )
    )
  }, [handleSuspend])

  return (
    <div className={classNames(styles.pointCard__container)}>
      <h2 className={classNames(styles.pointCard__headline)}>カード情報</h2>
      <p>ステータス : {PointCardStatus[pointCard.status]}</p>
      <p>ポイントカード保持者 : {pointCardUsersAmount.toLocaleString()}名</p>
      <p>有効期限 : {getExpiration(pointCard.expiration, 'card')}</p>
      <h2 className={classNames(styles.pointCard__headline)}>特典情報</h2>
      <PointCardOfferList pointCardOffers={pointCardOffers} />
      <BlueButton label={'特典を作成する'} onClick={handleCreateOffer} size={'short'} type={'outlined'} />
      {pointCard.status === 'suspended' && (
        <BlueButton
          disabled={pointCardOffers.length === 0}
          label={'公開する'}
          onClick={handlePublish}
          size={'short'}
          type={'main'}
        />
      )}
      {pointCard.status === 'active' && (
        <BlueButton label={'新規受付停止'} onClick={handleOpenConfirmModal} size={'short'} type={'main'} />
      )}
    </div>
  )
}

export default PointCardCard
